import { getEncodedParams } from 'helpers/encodeParams';

export const channelDataEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    // TODO: Deprecate once we switch off tactic entirely
    if (params.tactic && !params.channel) {
        params.channel = params.tactic;
    }
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/channel/${params.channel}?start=${encodedParams.start}&end=${encodedParams.end}`;
};

export const channelCalloutsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    // TODO: Deprecate once we switch off tactic entirely
    if (params.tactic && !params.channel) {
        params.channel = params.tactic;
    }
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/channel/${params.channel}/callouts?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.channelCreativesEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/channel/${params.channel}/creatives?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.channelDynamicCreativesEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/dynamic-creatives/${params.channel}?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.channelTargetingTacticsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/channel/${params.channel}/targeting?start=${encodedParams.start}&end=${encodedParams.end}`;
};

export const requestChannelUpsellEndpoint = (state, params) => `${state.config.apiUrl}/v1/entity/${params.entityId}/uptake/${params.channel}`;



// WEBPACK FOOTER //
// ./src/services/channel/selectors.js